// 硬编码头像数据索引文件
// 这个文件包含所有用户头像的动态导入
// 生成时间: 2025-08-25T07:31:54.853Z
// 数据来源: D1 数据库

export interface AvatarData {
  username: string
  data: string // base64 格式的图片数据
}

// 用户头像文件映射
const AVATAR_FILES: Record<string, () => Promise<{ default: AvatarData }>> = {
  "06cd69f6-470f-40a5-b1d0-096ba78f7d7f": () => import("./avatars/06cd69f6-470f-40a5-b1d0-096ba78f7d7f")
}

// 用户信息映射（用于快速查找，不包含头像数据）
const USER_INFO: Record<string, { username: string; fileName: string }> = {
  "06cd69f6-470f-40a5-b1d0-096ba78f7d7f": { username: "柳杨", fileName: "06cd69f6-470f-40a5-b1d0-096ba78f7d7f" }
}

/**
 * 异步获取用户的硬编码头像
 * @param userId 用户ID
 * @returns base64 格式的头像数据，如果不存在则返回 null
 */
export async function getHardcodedAvatar(userId: string): Promise<string | null> {
  const importFn = AVATAR_FILES[userId]
  if (!importFn) {
    return null
  }
  
  try {
    const module = await importFn()
    return module.default.data
  } catch (error) {
    console.warn('加载头像数据失败:', error)
    return null
  }
}

/**
 * 同步检查用户是否有硬编码头像
 * @param userId 用户ID
 * @returns 是否存在硬编码头像
 */
export function hasHardcodedAvatar(userId: string): boolean {
  return userId in AVATAR_FILES
}

/**
 * 获取所有有硬编码头像的用户ID列表
 * @returns 用户ID数组
 */
export function getHardcodedAvatarUserIds(): string[] {
  return Object.keys(AVATAR_FILES)
}

/**
 * 获取用户信息（不包含头像数据）
 * @param userId 用户ID
 * @returns 用户信息或 null
 */
export function getUserInfo(userId: string): { username: string; fileName: string } | null {
  return USER_INFO[userId] || null
}

/**
 * 获取硬编码头像的统计信息
 * @returns 统计信息对象
 */
export function getHardcodedAvatarStats() {
  const userIds = getHardcodedAvatarUserIds()
  
  return {
    count: userIds.length,
    totalSizeKB: 1334,
    averageSizeKB: 1334,
    files: userIds.map(userId => ({
      userId,
      username: USER_INFO[userId].username,
      fileName: USER_INFO[userId].fileName
    }))
  }
}

// 向后兼容的同步函数（已废弃，建议使用异步版本）
export function getHardcodedAvatarSync(_userId: string): string | null {
  console.warn('getHardcodedAvatarSync 已废弃，请使用 getHardcodedAvatar 异步版本')
  return null
}
